import React, {useEffect, useState} from 'react';
import { Button, Input, Loading, Checkbox, Tag } from '@alifd/next';
import { Servlets } from '@/service';
import LzDialog from '@/components/common/LzDialog';
import styles from './index.module.scss';
import goodsLineTips from '@/assets/images/CrossCategory/goods-line-tips.png'

const ProductLineDialog = ({fatherProductId, changeProductId, fatherProductList, changeProductList, closeDialog ,repeatObj,params, setParams,setForLine,setForSku,setRepeatNum}) => {
  const {Group: TagGroup, Selectable: SelectableTag} = Tag;
  // loading
  const [isLoading, setLoading] = useState(false);
  // 全部商品分组List
  const [productLineListAll,setProductLineListAll] = useState([]);
  // 商品分组List
  const [productLineList,setProductLineList] = useState([]);
  // 选中的商品分组id临时数据
  const [chooseProductIdCopy, setChooseProductIdCopy] = useState([]);
  // 选中的商品分组临时数据
  const [chooseProductCopy, setChooseProductCopy] = useState([]);
  // 商品分组筛选数据
  const [productFilter,setProductFilter] = useState({
    name:'',
    productLineType:'',
  });
  // 全选
  const [isSelectAll, setSelectAll] = useState(false);
  // 获取商品分组列表
  const getProductLine = (val,type) =>{
    setLoading(true)
    Servlets('getProductLineList', {
      pageNo: 1,
      pageSize:100,
      ...val
    }).then((result) => {
      setLoading(false)
      result.data.forEach(item => {
        if(fatherProductId.includes(item.id) || chooseProductIdCopy.includes(item.id)) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      })
      if(type === 1) {
        setProductLineListAll(result.data);
      }
      // 是否全选
      let flag = result.data.every(value => {
        return value.checked === true
      })
      if(!flag) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
      // if(fatherProductId.length === result.data.length) {
      //   setSelectAll(true);
      // }
      setProductLineList(result.data)
    }).catch((err) => {
      setLoading(false)
    });
  };
  // 重置商品分组筛选数据
  const resetProduct = () =>{
    setSelectAll(false);
    setProductFilter({
      name:'',
      productLineType:'',
    });
    getProductLine({name:'',productLineType:'',});
  }
  // 查看详细信息弹窗
  const [dialogFlag, setDialogFlag] = useState(false);
  // 查看商品分组详情
  const [productDetail,setDroductDetail] = useState({});

  const confirm = () => {
    // console.log(chooseProductIdCopy,chooseProductCopy);
    changeProductId(chooseProductIdCopy);
    changeProductList(chooseProductCopy);
    closeDialog();
    // 已选商品分组的所有skuid
    let productId = []
    chooseProductCopy.forEach((item,index)=>{
      productId = productId.concat(item.skus.split(','))
    })
    let temp = []
    temp = new Array(productId.length).fill('')
    // 为所有sku添加商品分组信息和对象(按商品分组录入)
    let tempIndex = 0
    chooseProductCopy.forEach((item,index)=>{
      item.skus.split(',').forEach((skus,skuIndex)=>{
        temp[tempIndex++] = {
          "productId":item.id,
          "skuId": skus,
          "day": 1
        }
      })
    })
    setForLine(temp,productId,1)
    // 录入2
    let record2 = []
    record2 = new Array(Array.from(new Set(productId)).length).fill('')
    // 为所有sku添加商品分组信息和对象(按sku录入)
    Array.from(new Set(productId)).forEach((item,index)=>{
      record2[index] = {
        "productId":'',
        "skuId":item,
        "day": 1
      }
    })
    setForSku(record2,[...Array.from(new Set(productId))],2)
    // console.log(record2,'rocord2');
    // setId(productId) // 被选择的所有skuid
    let tempArr = [...productId].sort()
    // console.log(productId);
    let repeatArr = []
    // 找出哪些元素是重复的
    if(tempArr.length>1){
      for(let i = 1;i<tempArr.length;i++){
        if(tempArr[i] === tempArr[i-1]){
          repeatArr.push(tempArr[i])
        }
      }
    }
    let sucArr = Array.from(new Set([...productId])) //总数组去重后
    // 去重完的就是所有重复的
    repeatArr = Array.from(new Set(repeatArr))//所有重复元素（各一个）
    setRepeatNum(repeatArr)

    let sucNum = sucArr.length - repeatArr.length // 有效数据 = 去重完的总数组（包含重复元素各一个） - 所有重复元素（各一个）
    let repNum = productId.length - sucNum // 无效数据 = 总数 - 有效
    repeatObj({
      repArr:repeatArr,
      suc:sucNum,
      rep:repNum
    })
    // // 为每一个sku创建对应的对象
    let param = {...params}
    param.viewButton.secondHalf.addParam.productLineList = new Array(chooseProductCopy.length).fill('')
    chooseProductCopy.forEach((item,index)=>{
      param.viewButton.secondHalf.addParam.productLineList[index] = {
        "productId": item.id,
        "day": 1,
        "name":item.productLineName
      }
    })
    setParams(param)
  }

  useEffect(() => {
    getProductLine(productFilter, 1); //查询所有的商品分组
  }, [])
  // 选择商品分组
  useEffect(() => {
    if(chooseProductIdCopy.length>0) {
      let arr = [];
      chooseProductIdCopy.forEach(item => {
        productLineListAll.forEach(val => {
          if(item === val.id) {
            arr.push(val);
          }
        })
      })
      setChooseProductCopy(arr);
    } else {
      setChooseProductCopy([]);
    }

  }, [chooseProductIdCopy])

  // 选中的商品分组回显
  useEffect(() => {
    setChooseProductIdCopy(fatherProductId);
    setChooseProductCopy(fatherProductList);
  }, [fatherProductId])

  return (
    <Loading visible={isLoading} fullScreen>
      <div className="auto-market-product-dialog">
        <div className={styles.filterData}>
          <div className={styles['input-box']}>
            <div className={styles.mb10}>商品分组名称：</div>
            <Input className={styles.w250} value={productFilter.name} onChange={(name) => {setProductFilter({...productFilter,name})}} placeholder="请输入" />
          </div>
          <div className={styles['input-box']}>
            <div className={styles.mb10}>商品分组类型：</div>
            <Input className={styles.w250} value={productFilter.productLineType} onChange={(productLineType) => {setProductFilter({...productFilter,productLineType})}} placeholder="请输入" />
          </div>
          <div className={styles.w250} style={{textAlign: "right"}}>
            <Button className={`${styles.mr10} ${styles.w88}`} type="primary" onClick={()=> getProductLine(productFilter)}>查询</Button>
            <Button className={`${styles.w88}`} type="normal" onClick={()=> {resetProduct()}}>重置</Button>
          </div>
        </div>
        <div>
        <div style={{padding: "0px 0px 10px 30px"}}>
          { productLineList.length > 0 && <div>
            <Checkbox checked={isSelectAll} onChange={(v) => {
              setSelectAll(v);
              const idArr = productLineList.map(v => v.id);
              if(v) {
                const arr = productLineList.map(v => {
                  v.checked = true;
                  return v;
                })
                let set = new Set([...chooseProductIdCopy, ...idArr]);
                let newIdArr = Array.from(set);
                setProductLineList(arr);
                setChooseProductIdCopy(newIdArr);
                setChooseProductCopy(arr);
              } else {
                const arr = productLineList.map(v => {
                  v.checked = false;
                  return v;
                })
                setProductLineList(arr);
                const newIdArr = chooseProductIdCopy.filter(elem => idArr.indexOf(elem) === -1);
                setChooseProductIdCopy(newIdArr);
              }
            }} >本页全选</Checkbox>
          </div>}
          <div style={{ marginTop: 15, height: productLineList.length > 4 ? "380px" : "", overflowY: productLineList.length > 4 ? "auto" : "hidden" }}>
            {
              productLineList.length > 0 ?
                <div>
                  <TagGroup className={styles.flexBox}>
                    {
                      productLineList.map((item) =>
                        <SelectableTag
                          className={styles['select-tag']}
                          key={item.id}
                          checked={item.checked}
                          onChange={(v) => {
                            if(v) {
                              setChooseProductIdCopy([
                              ...chooseProductIdCopy,
                              item.id
                              ])
                            } else {
                              let newArr = chooseProductIdCopy.filter(val => val !== item.id)
                              setChooseProductIdCopy(newArr);
                            }
                            const arr = productLineList.map(val => {
                              if(item.id === val.id) {
                              val.checked = v;
                              }
                              return val;
                            })
                            setProductLineList(arr);
                            // 是否全选
                            let flag = arr.every(value => {
                              return value.checked === true
                            })
                            if(!flag) {
                              setSelectAll(false);
                            } else {
                              setSelectAll(true);
                            }
                            }}
                          >
                            <div className={styles.innerBox}>
                              <div className={styles['name-box']}>
                                <img src={goodsLineTips} className={styles['tips-icon']}/>
                                <div title={item.productLineName} className={`${styles.innerTitle} ${styles.clamp1}`}>{item.productLineName}</div>
                              </div>
                              <div title={item.productLineDes} className={styles.innerContent}>{item.productLineDes}</div>
                              <div title={`${item.productLineType} ${item.productLineLv || 0}级`} className={`${styles.productName} ${styles.clamp1}`}><div>商品分组类型/级别：</div><div className={styles['red-text-box']}>{`${item.productLineType} ${item.productLineLv || 0}级`}</div></div>
                              <div className={styles.productName} style={{margin: "0px 0px 15px 19px"}}><div>商品分组包含：</div><div className={styles['red-text-box']}>{item.skuNumber}个SKU</div></div>
                              <Button type="primary" className="table-cell-btn" text style={{float: "left", marginLeft: 19}} onClick={(e) => {setDroductDetail(item),setDialogFlag(true),e.stopPropagation()}}>查看详细信息</Button>
                            </div>
                          </SelectableTag>
                      )
                    }
                </TagGroup>
                </div>

                : <div style={{textAlign: 'center'}}>暂无数据</div>
            }
          </div>
        </div>
        <hr />
        <div style={{textAlign: 'right',padding: '20px 30px 15px 0'}}>
          <Button type="normal" className={`${styles.mr10} ${styles.w88}`} onClick={() => {closeDialog()}}>取消</Button>
          <Button type="primary" className={`${styles.w88}`} onClick={confirm}>确认</Button>
        </div>
        </div>
      </div>

      <LzDialog footer={false} style={{width: '560px'}} title="查看商品分组信息" shouldUpdatePosition visible={dialogFlag}
        onClose={() => setDialogFlag(false)}>
          <div style={{padding: '30px'}}>
            <div className={styles.detailText}>商品分组名称：{productDetail.productLineName}</div>
            <div
              className={`${styles.detailText} ${styles.mt20}`}
            >
              <div className={styles.ml10}> SKU 列表：<span className={styles.skuText}>{productDetail.skus}</span></div>
            </div>
          </div>
      </LzDialog>
    </Loading>
  )
}

export default ProductLineDialog
